import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { License } from '../../../stores/types';
import { MODAL_TYPES, MenuItem, useGlobalModalContext } from '../../_ui';
import LicenseDetails from '../LicenseDetails.component';

interface ViewLicenseDetailsMenuItemProps {
  license: License;
}

export const ViewLicenseDetailsMenuItem: React.FC<ViewLicenseDetailsMenuItemProps> = ({
  license,
}) => {
  const { showModal } = useGlobalModalContext();
  const { t } = useTranslation();

  const handleViewLicenseClick = useCallback(() => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('license_details'),
      height: 'fit-content',
      bodyStyleClass: 'flex-grow',
      onRenderBody: () => <LicenseDetails license={license} />,
    });
  }, [showModal, t, license]);

  return (
    <MenuItem
      label={t('view_license_details')}
      dataTestId='view-license-details'
      onClick={handleViewLicenseClick}
    />
  );
};
